import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input
} from "reactstrap"
import { Link } from "react-router-dom"
import { connect } from "react-redux"

//import Charts
import StackedColumnChart from "./StackedColumnChart"

import modalimage1 from "../../assets/images/product/img-7.png"
import modalimage2 from "../../assets/images/product/img-4.png"

//import action
import { getChartsData } from "../../store/actions"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import MonthlyEarning from "./MonthlyEarning"
import SocialSource from "./SocialSource"
import Comments from "./Comments"
import ActivityComp from "./ActivityComp"
import TopCities from "./TopCities"
import LatestTranaction from "./LatestTranaction"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import classNames from "classnames";


import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'


import HC_more from "highcharts/highcharts-more"; //module
HC_more(Highcharts); //init module

require("highcharts/modules/draggable-points")(Highcharts); 

window.Highcharts = Highcharts;


function subtractMonths(numOfMonths, date = new Date()) {
  date.setMonth(date.getMonth() - numOfMonths);

  return date;
}

const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const currentDate = new Date();

const prevDate = new Date();
prevDate.setMonth(prevDate.getMonth() - 1);

const prev2Date = new Date();
prev2Date.setMonth(prev2Date.getMonth() - 2);

const prev3Date = new Date();
prev3Date.setMonth(prev3Date.getMonth() - 3);

const prev4Date = new Date();
prev4Date.setMonth(prev4Date.getMonth() - 4);

const monthLabels = [ month[currentDate.getMonth()].concat(' ', currentDate.getFullYear()), 
                      month[prevDate.getMonth()].concat(' ', prevDate.getFullYear()), 
                      month[prev2Date.getMonth()].concat(' ', prev2Date.getFullYear()), 
                      month[prev3Date.getMonth()].concat(' ', prev3Date.getFullYear()),
                      month[prev4Date.getMonth()].concat(' ', prev4Date.getFullYear()),
                    ]


const quota = {
  'quota': [
      ['e-mails sent', 300],
      ['Cold calls', 200],
      ['Meetings', 150],
      ['Opps in Pipeline', 200],
      ['Opps Won', 100]
  ]
};




const data = {
  4: [
    ['e-mails sent', 234],
    ['Cold calls', 156],
    ['Meetings', 60],
    ['Opps in Pipeline', 34],
    ['Opps Won', 54]
  ],
  3: [
    ['e-mails sent', 202],
    ['Cold calls', 203],
    ['Meetings', 76],
    ['Opps in Pipeline', 100],
    ['Opps Won', 75]
  ],
  2: [
    ['e-mails sent', 356],
    ['Cold calls', 252],
    ['Meetings', 115],
    ['Opps in Pipeline', 286],
    ['Opps Won', 98]
  ],
  1: [
    ['e-mails sent', 378],
    ['Cold calls', 206],
    ['Meetings', 152],
    ['Opps in Pipeline', 243],
    ['Opps Won', 105]
  ],
   0: [
      ['e-mails sent', 147],
      ['Cold calls', 123],
      ['Meetings', 84],
      ['Opps in Pipeline', 221],
      ['Opps Won', 67]
  ]
};

const lbl = [{
  name: 'e-mails sent',
  icon: 'far fa-envelope',
  color: '#003f5c'
},{
  name: 'Cold calls',
  icon: 'fas fa-phone-volume',
  color: '#58508d'
},{
  name: 'Meetings',
  icon: 'far fa-calendar-check',
  color: '#bc5090'
}, {
  name: 'Opps in Pipeline',
  icon: 'fas fa-wave-square',
  color: '#ff6361'
}, {
  name: 'Opps Won',
  icon: 'fas fa-money-bill-alt',
  color: '#ffa600'
}];


const getData = data => data.map((month, i) => ({
  name: month[0],
  y: month[1],
  color: lbl[i].color
}));

const options = {
  chart: {
      type: 'column',
      height: 450
  },
  title: {
      text: ''
  },

  plotOptions: {
      series: {
        dragDrop: {
            // draggableY: true,
            dragPrecisionY: 1
        },
        // stickyTracking: false,
          grouping: false,
          borderWidth: 0
      },
      column: {

        borderRadius: 5,
          minPointLength: 2
      },
      line: {
          cursor: 'ns-resize'
      }
  },
  legend: {
      enabled: false
  },
  tooltip: {
      valueDecimals: 0,
      shared: true,
      fontFamily: 'Libre Franklin, sans-serif',
      headerFormat: '<span style="font-weight:bold">{point.point.name}</span><br/><br/>',
      pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
      borderWidth: 0,
      shadow: false
  },
  xAxis: {
      type: 'category',
      max: 4,
      labels: {
          useHTML: true,
          animate: true,
          formatter: ctx => {
              let icon;
              let name;

              lbl.forEach(function (label) {
                  if (label.name === ctx.value) {
                      icon = label.icon;
                      name = label.name;
                  }
              });

              return `<span><i class=\"${icon}\"></i></span><span> ${name}</span>`;
          },
          style: {
              textAlign: 'center',
              fontFamily: 'Libre Franklin, sans-serif',
              fontSize: '12.5px'
          }
      }
  },
  yAxis: [
    
    {
      allowDecimals: false,
      minRange: 1,
      title: {
          text: ''
      } ,
      softMin: 0,
      softMax: 400
  }],
  series: [{
      color: 'rgb(239, 242, 247)',
      pointPlacement: -0.2,
      linkedTo: 'main',
      data: quota['quota'].slice(),
      name: 'Quota'
  }, {
      name: monthLabels[0],
      id: 'main',
      dataLabels: [{
          enabled: true,
          allowDecimals: false,
          minRange: 1,
          // inside: true,
          style: {
              fontSize: '16px',
              color: '#495057',
              fontFamily: 'Libre Franklin, sans-serif'
          }
      }],
      data: getData(data[0]).slice()
  }],
  exporting: {
      allowHTML: true
  }
}


class Dashboard extends Component {


  constructor(props) {
    super(props)

    this.chartOptions = options;
    this.state = {
      
      reports: [
        { title: "Activities Completed", iconClass: "bx bx-check-square", description: "34,235" },
        {
          title: "Meeting Hours",
          iconClass: "bx bxs-phone-call",
          description: "65,723",
        },
        {
          title: "Total Closed",
          iconClass: "bx bx-dollar-circle",
          description: "$6,453,234",
        },
      ],
      email: [
        { title: "Week", linkto: "#", isActive: false },
        { title: "Month", linkto: "#", isActive: false },
        { title: "Year", linkto: "#", isActive: true },
      ],
      modal: false,
      subscribemodal: false,
      chartSeries: [],
      periodType: "Mar 2022"
    }

    this.togglemodal.bind(this)
    this.togglesubscribemodal.bind(this)
  }

  componentDidMount() {
    const { onGetChartsData } = this.props;
    setTimeout(() => this.setState({ subscribemodal: true }), 2000);
  }


  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }



  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }))
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, chartSeries: this.props.chartsData })
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Home | Strive - Achieve your goals</title> 
          </MetaTags>
          <Container fluid>

            {/* Render Breadcrumb */}
            <Breadcrumbs title="Strive" breadcrumbItem="Home" />
            <Row>
              <Col xl="4">
                <WelcomeComp />
                <MonthlyEarning />
              </Col>
              <Col xl="8">
                <Row>
                  {/* Reports Render */}
                  {this.state.reports.map((report, key) => (
                    <Col md="4" key={"_col_" + key}>
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description}</h4>
                            </div>
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                              <span className="avatar-title">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                />
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>

                <Card>
                  <CardBody>
                    <div className="d-sm-flex flex-wrap">
                      <CardTitle className="card-title mb-4 h4">
                        Monthly Trends
                      </CardTitle>
                      <div className="ms-auto">
                        <ul className="nav nav-pills">
                        <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { "active": this.state.periodType === "Nov 2021" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({ ...this.state, periodType: "Nov 2021" });
                                this.chartOptions = {
                                  series: [{
                                      data: quota['quota'].slice(),
                                      name: 'Quota'
                                  }, {
                                      name:  monthLabels[4],
                    
                                      data: getData(data[4]).slice()
                                  }]
                                }
                              }}
                              id="one_month"
                            >
                              {monthLabels[4]}
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { "active": this.state.periodType === "Dec 2021" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({ ...this.state, periodType: "Dec 2021" });
                                this.chartOptions = {
                                  series: [{
                                      data: quota['quota'].slice(),
                                      name: 'Quota'
                                  }, {
                                      name: monthLabels[3],
                    
                                      data: getData(data[3]).slice()
                                  }]
                                }
                              }}
                              id="one_month"
                            >
                              {monthLabels[3]}
                            </Link>
                          </li>
                          

                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { "active": this.state.periodType === "Jan 2022" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({ ...this.state, periodType: "Jan 2022" });
                                this.chartOptions = {
                                  series: [{
                                      data: quota['quota'].slice(),
                                      name: 'Quota'
                                  }, {
                                      name: monthLabels[2],
                    
                                      data: getData(data[2]).slice()
                                  }]
                                }
                              }}
                              id="one_month"
                            >
                             {monthLabels[2]}
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { "active": this.state.periodType === "Feb 2022" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({ ...this.state, periodType: "Feb 2022" });
                                this.chartOptions = {
                                  series: [{
                                      data: quota['quota'].slice(),
                                      name: 'Quota'
                                  }, {
                                      name: monthLabels[1],
                    
                                      data: getData(data[1]).slice()
                                  }]
                                }
                              }}
                              id="one_month"
                            >
                              {monthLabels[1]}
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { "active": this.state.periodType === "Mar 2022" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({ ...this.state, periodType: "Mar 2022" });
                                this.chartOptions = {
                                  series: [{
                                      data: quota['quota'].slice(),
                                      name: 'Quota'
                                  }, {
                                      name: monthLabels[0],
                                      data: getData(data[0]).slice()
                                  }]
                                }
                              }}
                              id="one_month"
                            >
                              {monthLabels[0]}
                            </Link>{" "}
                          </li>
                        </ul>
                      </div>              
                    </div>
                    <div className="clearfix" />
                    {/* <StackedColumnChart chartSeries={this.state.chartSeries} /> */}
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={this.chartOptions}
                      ref={ this.chartRef }
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col xl="4">
                <ActivityComp />
              </Col>
              <Col xl="4">
                <Comments />
              </Col>
              <Col xl="4">
                <TopCities />
              </Col>
            </Row>
          </Container>
        </div>


        <Modal
          isOpen={this.state.modal}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          tabindex="-1"
          toggle={this.togglemodal}
        >
          <div className="modal-content">
            <ModalHeader toggle={this.togglemodal}>Order Details</ModalHeader>
            <ModalBody>
              <p className="mb-2">
                Product id: <span className="text-primary">#OP2540</span>
              </p>
              <p className="mb-4">
                Billing Name:{" "}
                <span className="text-primary">Neal Matthews</span>
              </p>

              <div className="table-responsive">
                <Table className="table align-middle table-nowrap">
                  <thead>
                    <tr>
                      <th scope="col">Product</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage1} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Solid Color T-Shirt
                          </h5>
                          <p className="text-muted mb-0">$ 225 x 1</p>
                        </div>
                      </td>
                      <td>$ 255</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage2} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Hoodie (Blue)
                          </h5>
                          <p className="text-muted mb-0">$ 145 x 1</p>
                        </div>
                      </td>
                      <td>$ 145</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Sub Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Shipping:</h6>
                      </td>
                      <td>Free</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="secondary"
                onClick={this.togglemodal}
              >
                Close
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func
}

const mapStateToProps = ({ Dashboard }) => ({
  chartsData: Dashboard.chartsData,
})

const mapDispatchToProps = dispatch => ({
  onGetChartsData: (periodType) => dispatch(getChartsData(periodType)),
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(withTranslation()(Dashboard))

